export enum UserType {
    ROOT="ROOT", INTERNAL="INTERNAL", EXTERNAL="EXTERNAL",TECH = "TECH", CUSTOMER = "CUSTOMER", COLLECTOR = "COLLECTOR"
}